import AbstractController from '../../../../../vendors/services/abstractController';
import {useState} from 'react';
import EventoService from '../../../../services/evento.service';

export default class MeusEventosController extends AbstractController {

  public service: EventoService;

  public tab: any;
  public setTab: any;
  public list: any;
  public setList: any;
  public total: any;
  public setTotal: any;

  public lazyParams: any;
  public setLazyParams: any;

  constructor() {
    super();
    [this.tab, this.setTab] = useState('');
    [this.list, this.setList] = useState([]);
    [this.total, this.setTotal] = useState(0);
    [this.lazyParams, this.setLazyParams] = useState({
      first: 0,
      rows: 6,
      page: 1,
    });
    this.service = new EventoService();
  }

  init() {
    const state = this.location.state;
    super.init();
    if (!!state && !!state.desiredTab) {
      this.changeTab(state.desiredTab);
    } else {
      const params = new URLSearchParams(window.location.search);
      if (params.get('tab') != undefined) {
        this.changeTab(params.get('tab'));
      } else {
        this.changeTab('1');
      }
    }
  }

  onPage(e: any) {
    this.changeTab(this.tab, e.page, e.rows, false, e);
  }


  changeTab(value: any, page: number = 0, pageSize: number = 6, isClean = false, e?: any, ordering: any = null) {
    const obj: any = {
      codigoContribuinte: this.getCodContribuinte(),
      codigoMeuEventoSituacao: value,
      pageSize: 6
    };
    obj.page = page;
    obj.pageSize = pageSize;
    if (isClean) {
      obj.page = 0;
      obj.pageSize = 6;
    }
    if (ordering != null) {
      obj.ordering = ordering;
    }
    this.start();
    this.service.getMeusEventos(obj).then((res: any) => {
      this.setTab(value);
      this.stop();
      if (e) {
        this.setLazyParams(e);
      }
      if (res.result && res.result.items) {
        this.setList(res.result.items);
        this.setTotal(res.result.totalItems);
      } else {
        this.setList([]);
        this.setTotal(0);
      }
    }).catch((err) => this.stop());
  }


}
